import { FunctionComponent } from 'react'
import ReactAvatar from 'react-avatar'
import ReactTooltip from 'react-tooltip'
import { v4 } from 'uuid'
import ITeam from '../../../api/types/team'
import IUser from '../../../api/types/user'
import { Assignee } from '../../../types/FolderChecklist'

interface IProps {
  users: IUser[]
  teams: ITeam[]
  place?: string | null
}

interface AssigneeProps {
  assignees?: Assignee[] | null
  place?: string | null
}

export const TableAssignees: FunctionComponent<AssigneeProps> = ({ assignees, place }) => {
  if (!assignees || !Array.isArray(assignees) || assignees.length === 0) return null
  const tooltipId = v4()
  if (assignees.length === 1) {
    const [tester] = assignees
    return (
      <div
        data-tip={tester.name}
        data-for={tooltipId}
        data-place={place}
        className="table-avatar-display"
      >
        <ReactAvatar
          src={tester.url ? tester.url : null}
          size="32"
          round
          name={tester.name}
        />
        <ReactTooltip
          id={tooltipId}
          isCapture
        />
      </div>
    )
  }

  const tooltip = assignees.map((u) => u.name).join('<br/>')

  return (
    <div
      data-tip={tooltip}
      data-for={tooltipId}
      data-multiline="true"
      data-place={place}
      className="table-avatar-display"
    >
      <ReactAvatar name={assignees.length.toString()} round size="32" />
      <ReactTooltip
        id={tooltipId}
        isCapture
      />
    </div>
  )
}

// shows the avatars of responsible users
// if there are 3 or more users then only the avatar of the first user is shown
// and the count of users
export default function TableAvatarDisplay({ users = [], teams = [], place }: IProps) {
  if (users.length === 0 && teams.length === 0) {
    return null
  }

  const usersAndTeams: any[] = [...users, ...teams]

  const tooltipId = v4()

  if (usersAndTeams.length === 1) {
    const tester = usersAndTeams[0]

    // if it has a firstname it is a user
    if (typeof tester.firstname !== 'undefined') {
      return (
        <div
          data-tip={`${tester.firstname} ${tester.lastname}`}
          data-for={tooltipId}
          data-place={place}
          className="table-avatar-display"
        >
          <ReactAvatar
            src={tester.avatar && tester.avatar.thumb ? tester.avatar.thumb.url : null}
            size="32"
            round
            name={`${tester.firstname} ${tester.lastname}`}
          />
          <ReactTooltip
            id={tooltipId}
            isCapture
          />
        </div>
      )
    }
    // if it isn't a user then it is a team
    return (
      <div
        data-tip={`${tester.name}`}
        data-for={tooltipId}
        data-place={place}
        className="table-avatar-display"
      >
        <ReactAvatar
          src={tester.avatar && tester.avatar.thumb ? tester.avatar.thumb.url : null}
          size="32"
          round
          name={`${tester.name}`}
        />
        <ReactTooltip
          id={tooltipId}
          isCapture
        />
      </div>
    )
  }

  const tooltip = usersAndTeams.map((u) => (typeof u.firstname !== 'undefined'
    ? `${u.firstname} ${u.lastname}` : u.name)).join('<br/>')

  return (
    <div
      data-tip={tooltip}
      data-for={tooltipId}
      data-multiline="true"
      data-place={place}
      className="table-avatar-display"
    >
      <ReactAvatar name={usersAndTeams.length.toString()} round size="32" />
      <ReactTooltip
        id={tooltipId}
        isCapture
      />
    </div>
  )
}
